module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e86"
    }
  }, [_c('b', [_c('i', [_vm._v("For my husband")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d12e90"
    }
  }, [_c('b', [_vm._v("K")]), _c('b', [_vm._v("EN ")]), _c('b', [_vm._v("T")]), _c('b', [_vm._v("ADA")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e99"
    }
  }, [_c('i', [_vm._v("who has journeyed alongside my wheelchair ")]), _c('i', [_vm._v("these many years, giving love and support ")]), _c('i', [_vm._v("every step of the way.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310262984_content_0005_005",
      "id": "d12e106",
      "src": "images/0310262984_content_0005_005.jpg"
    }
  })]), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e107"
    }
  }, [_c('b', [_c('i', [_vm._v("For")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d12e111"
    }
  }, [_c('b', [_vm._v("S")]), _c('b', [_vm._v("TEVE ")]), _c('b', [_vm._v("E")]), _c('b', [_vm._v("STES")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e120"
    }
  }, [_c('i', [_vm._v("whose teaching from God’s Word ")]), _c('br'), _c('i', [_vm._v("has enriched my life these many years.")]), _c('br'), _c('i', [_vm._v("If anyone gleans something precious from this book, ")]), _c('br'), _c('i', [_vm._v("I probably learned it first from him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2877d756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tada_9780310297864_epub_c2b_r1.vue
// module id = 69
// module chunks = 0